import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import { Client, AddClient, EditClient, ImportClient } from "./pages";

const clientRoutes = [
  {
    path: "/client",
    element: (
      <ProtectedRoute name="client">
        <Client />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="client" defaultTitle="client.title" />
    ),
  },
  {
    path: "/client/import",
    element: (
      <ProtectedRoute name="client_add">
        <ImportClient />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="client.import_client" />,
  },
  {
    path: "/client/add",
    element: (
      <ProtectedRoute name="client_add">
        <AddClient />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="client.add_client" />,
  },
  {
    path: "/client/edit/:id",
    element: (
      <ProtectedRoute name="client_edit">
        <EditClient />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="client.edit_client" />,
  },
];

export default clientRoutes;
